import styled from 'styled-components';
import { ShoppingCartOutlined } from '@ant-design/icons';

export const ShoppingCartIcon = styled(ShoppingCartOutlined)`
  font-size: 16px;
  color: #666;
`;
